import { Alert, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ShopsHelper from 'helpers/ShopsHelper';

/**
 * Display subscription ending soon alert if the current shop's subscription plan is going to end in the next 7 days
 * @param props - { shop, notifications }
 * @returns SubscriptionEndingSoonAlertView
 */
export default function SubscriptionEndingSoonAlert(props) {
  const { shop, notifications } = props;
  const { t: tPopup } = useTranslation('popup');
  const [subscriptionRemainingDays, setSubscriptionRemainingDays] = useState(null);
  const [highlightedNotification, setHighlightedNotification] = useState(null);

  useEffect(() => {
    const remainingDays = Number(ShopsHelper.getSubscriptionRemainingDays(shop)) || null;

    if (remainingDays !== null && remainingDays >= 0 && remainingDays < 7) {
      setSubscriptionRemainingDays(remainingDays);
      setHighlightedNotification(null);
    } else {
      setSubscriptionRemainingDays(null);
      if (notifications?.length) {
        const highlightNotification = notifications.find(
          (notification) => notification?.should_highlight && !notification?.read
        );
        setHighlightedNotification(highlightNotification || null);
      } else {
        setHighlightedNotification(null);
      }
    }
  }, [shop, notifications]);

  const getSubscriptionExpiryMessage = (days) => {
    if (days === 0) {
      return tPopup('Your subscription validity ends today.');
    }
    if (days === 1) {
      return tPopup('Your subscription validity ends in {{days}} day.', { days });
    }
    return tPopup('Your subscription validity ends in {{days}} days.', { days });
  };

  const handleUpgradeClick = () => {
    window.dispatchEvent(new CustomEvent('open-plan-price'));
  };

  const renderUpgradeButton = () => (
    <Button
      variant="contained"
      size="small"
      onClick={handleUpgradeClick}
      sx={{
        backgroundColor: '#1d6df2',
        color: '#ffffff',
        textTransform: 'none',
        fontWeight: 700,
        borderRadius: '50px',
        padding: '3px 14px',
        fontSize: '12px',
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 8px rgba(29, 109, 242, 0.3)',
        '&:hover': {
          backgroundColor: '#1557b0',
        },
      }}
    >
      Upgrade Plan
    </Button>
  );

  const alertSx = {
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiAlert-action': {
      alignItems: 'center',
      padding: '0 0 0 16px',
    },
  };



  if (subscriptionRemainingDays !== null) {
    return (
      <Alert severity="warning" sx={alertSx} action={renderUpgradeButton()}>
        {getSubscriptionExpiryMessage(subscriptionRemainingDays)}
      </Alert>
    );
  }

  if (highlightedNotification) {
    return (
      <Alert severity="warning" sx={alertSx} action={renderUpgradeButton()}>
        {highlightedNotification?.title}
      </Alert>
    );
  }

  return null;
}

